// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a38d7389","239":"578bc93a","453":"0b16d7a5","455":"6c5ab796"}[chunkId] + ".chunk.js";
};